import SmartDateInput from '../inputs/SmartDateInput';
import createField from './createField';

const SmartDateField = createField(SmartDateInput);

export default SmartDateField;
